import type {FC} from 'react';
import {GridActionsCellItem, Icon, IconNames} from '@wellstone-solutions/web';
import {ALERT_TYPES, showAlert} from 'utils/showAlert';
import {copyNarrative} from './copyNarrative';

type CopyNarrativeActionProps = {
  narrative: string;
  // The grid reads this off the element to place it, so it must be a prop
  showInMenu: boolean;
};

export const CopyNarrativeAction: FC<CopyNarrativeActionProps> = ({
  narrative,
  showInMenu,
}) => (
  <GridActionsCellItem
    label="Copy narrative"
    icon={<Icon name={IconNames.Copy} size={22} />}
    showInMenu={showInMenu}
    disabled={!narrative}
    onClick={async () => {
      if (await copyNarrative(narrative)) {
        showAlert('Narrative copied', ALERT_TYPES.SUCCESS);
      }
    }}
  />
);
